import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateUiModule } from '@core/translation/translate-ui.module';
import { CreateSubprojectBtnTileModule } from '@features/projects/projects-list/create-subproject-btn-tile/create-subproject-btn-tile.module';
import { UnscheduledProjectMenuComponent } from '@shared/components/scheduler-calendar/unscheduled-project-menu/unscheduled-project-menu.component';
import { AppDatepickerModule } from '@ui-kit/app-datepicker/app-datepicker.module';
import { ButtonsModule } from '@ui-kit/buttons/buttons.module';

@NgModule({
  declarations: [UnscheduledProjectMenuComponent],
  imports: [CommonModule, AppDatepickerModule, ButtonsModule, MatMenuModule, TranslateUiModule, CreateSubprojectBtnTileModule],
  exports: [UnscheduledProjectMenuComponent]
})
export class UnscheduledProjectMenuModule {}
